
import { Modal } from 'react-bootstrap';
import PortletBody from '../../../app/components/portlet/PortletBody';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import { StyledLabel } from '../../../assets/styledComponents/Global';
import styled, { useTheme } from 'styled-components';
import Portlet from '../../../app/components/portlet/Portlet';
import ModalBgIcon from '../../../app/components/svgIcons/ModalBgIcon';
import ModalBgIcon2 from '../../../app/components/svgIcons/ModalBgIcon2';

const TimesUpModal = ({
    show,
    onHide,
    timeLeft,
    loading,
    onSave,
    setExpired,
    setReadyForAssessment
}) => {
    const theme = useTheme()


    const formatTime = (seconds) => {
        if (!seconds) return "Expired";
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${s < 10 ? "0" : ""}${s}`;
    };

    return (

        <Modal show={show} backdrop="static" centered onHide={onHide} size={'lg'}>


            <Modal.Body className="d-flex flex-column rounded position-relative" style={{ background: '#fff' }}>
                <Portlet style={{ background: '#fff' }} >
                    <PortletBody bgColor={'#fff'}>
                        <div className='d-flex flex-column justify-content-center align-items-center ' >

                            <StyledLabel size='32px' color={theme?.secondary} className="flex-grow-1 px-0 cursor-pointer flex-center pt-md-1 pb-md-0 font-fredoka fw-normal">
                                {formatTime(timeLeft)}

                            </StyledLabel>
                            <div>
                                <StyledLabel size={'14px'} weight={'600'} color={theme?.darktext} className="pb-md-3" >
                                    Hurry! Time is running out, submit your assessment </StyledLabel>
                            </div>
                        </div>
                        <div className="row px-4">
                            <div className={'d-flex align-items-center text-center col-md-12 my-3 p-4 rounded'} style={{ background: '#F5F5F5' }}>
                                <StyledLabel weight='400' size='14px' color={theme?.dark ? '#fff' : theme?.subText}>
                                    Your allotted time for the video assessment is running out. You can still save and submit your attempted questions. If you choose to save and submit, your video profile will be completed and sent. If you cancel, all your recorded answers will be deleted.
                                </StyledLabel>

                            </div>
                        </div>




                    </PortletBody>
                </Portlet>


                <div className="d-flex justify-content-center mb-5">
                    <div className="d-flex gap-3">

                        <StyledButton disabled={loading} variant='white' className="mb-2 " type='submit' onClick={() => { setReadyForAssessment(false); setExpired(true); onHide() }} >
                            Cancel & Exit
                        </StyledButton>
                        <StyledButton loading={loading} disabled={loading || timeLeft<=0} className="mb-2 border-0" type='submit' onClick={onSave

                        } >
                            Save & Submit
                        </StyledButton>
                    </div>
                </div>

                <StyledIcon>
                    <ModalBgIcon />
                </StyledIcon>


                <StyledIcon2>
                    <ModalBgIcon2 />
                </StyledIcon2>
            </Modal.Body>

        </Modal>

    );
}



export default TimesUpModal;


const StyledIcon = styled.div`
position:absolute;
bottom:50px;
right:100px;
`

const StyledIcon2 = styled.div`
position:absolute;
top:10px;
left:200px;
`

